export const productWidgetComponentId = 'abcd87fe-c51f-4538-848d-2902a2f50d2d';
